"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.107 4.28v1.17h13.786V4.28a.5.5 0 0 0-.5-.5H1.607a.5.5 0 0 0-.5.5Zm14.786 0v6.85h-1V6.85H1.107v4.87a.5.5 0 0 0 .5.5h14.199c-.202.59-.756 1-1.413 1H1.607c-.827 0-1.5-.672-1.5-1.5V4.28c0-.828.673-1.5 1.5-1.5h12.786c.827 0 1.5.672 1.5 1.5ZM1.983 9.97H8.03v-1H1.984v1Zm7.173 0h2.673v-1H9.156v1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.194 8.367V5.88c0-.318.26-.577.577-.577H22.23c.318 0 .577.259.577.577v2.487H1.194Zm22.737 8.767V5.88c0-.939-.764-1.702-1.702-1.702H1.77c-.937 0-1.7.763-1.7 1.702v12.24c0 .938.764 1.701 1.702 1.701H22.23a1.7 1.7 0 0 0 1.594-1.124H1.771a.577.577 0 0 1-.577-.577V9.942h21.612v7.192h1.125Zm-21.182-2.31h9.297v-1.125H2.749v1.125Zm15.138 0h-4.11v-1.125h4.11v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.592 11.157V7.84a.77.77 0 0 1 .77-.77h27.276a.77.77 0 0 1 .77.77v3.317H1.591Zm30.315 11.689V7.84a2.272 2.272 0 0 0-2.269-2.27H2.361A2.272 2.272 0 0 0 .092 7.84v16.32a2.272 2.272 0 0 0 2.27 2.269h27.276c.98 0 1.808-.627 2.126-1.5H2.361a.77.77 0 0 1-.769-.77V13.258h28.815v9.589h1.5ZM3.665 19.765H16.06v-1.5H3.665v1.5Zm20.184 0h-5.48v-1.5h5.48v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.62 10.474c-.734 0-1.331.598-1.331 1.332v5.213h43.423v-5.213c0-.734-.598-1.332-1.333-1.332H3.621Zm42.092 9.17v15.252h1.875v-23.09A3.211 3.211 0 0 0 44.38 8.6H3.621a3.21 3.21 0 0 0-3.207 3.207v24.387A3.21 3.21 0 0 0 3.62 39.4h40.758a3.212 3.212 0 0 0 2.92-1.879h-2.811a1.344 1.344 0 0 1-.109.004H3.621a1.334 1.334 0 0 1-1.332-1.332V19.644h43.423ZM6.081 29.443h18.521v-1.875H6.081v1.875Zm30.158 0h-8.187v-1.875h8.187v1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.827 13.966c-.979 0-1.776.797-1.776 1.776v6.95H60.95v-6.95c0-.98-.797-1.776-1.777-1.776H4.827ZM60.95 26.192v20.336h2.5V15.742a4.281 4.281 0 0 0-4.277-4.276H4.827a4.28 4.28 0 0 0-4.276 4.276v32.516a4.28 4.28 0 0 0 4.276 4.276h54.345a4.283 4.283 0 0 0 3.893-2.506h-3.748a1.767 1.767 0 0 1-.145.006H4.827a1.778 1.778 0 0 1-1.776-1.776V26.192H60.95ZM8.108 39.257h24.695v-2.5H8.108v2.5Zm40.21 0H37.404v-2.5H48.32v2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCreditCard = function IconCreditCard(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Credit Card' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CreditCard"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCreditCard.sizes = [16, 24, 32, 48, 64];
IconCreditCard.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCreditCard;
exports.default = _default;